import React from "react";
import "assets/styles/device/SecurityInfoDevice.scss";

const SecurityInfoDevice = () => {
  return (
    <div className={'securityInfoDeviceWrapper'}>
      <div className={'securityInfoDevice'}>
        <p className={'intro'}>
          En Etomin, ofrecemos soluciones seguras y eficientes para pagos con tarjeta presente, diseñadas para optimizar la experiencia de compra en tu negocio.
        </p>

        <p className={'highlight'}>
          Nuestras herramientas permiten aceptar pagos con tarjetas de crédito y débito directamente en el punto de venta, con procesamiento rápido, conexión estable y cumplimiento total con los estándares <strong>PCI DSS</strong> de seguridad.
        </p>

        <p>
          Con nuestras soluciones de tarjeta presente, tu negocio puede ofrecer a los clientes una experiencia de pago fluida, profesional y segura.
        </p>
      </div>
    </div>
  );
};

export default SecurityInfoDevice;
